import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const StyledSearchInput = styled(TextField)({
  minWidth: 200,
  marginTop: '-1px',
  '& .MuiInputBase-root': {
    fontSize: '1rem',
    paddingBottom: '8px',
    '&:before': {
      borderBottomColor: '#e0e0e0',
    },
    '&:hover:before': {
      borderBottomColor: '#999',
    },
    '&.Mui-focused:after': {
      borderBottomColor: '#38d219',
    },
  },
});

export default StyledSearchInput; 
